import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClockBack = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 21 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M10.544 19.75q-4.036 0-6.852-2.857T.875 9.973H2.5q0 3.385 2.33 5.769 2.328 2.383 5.714 2.383 3.44 0 5.823-2.41t2.383-5.85q0-3.359-2.41-5.674t-5.796-2.316q-1.843 0-3.453.84a9.4 9.4 0 0 0-2.804 2.22h2.844V6.56h-5.66V.927h1.625v2.87a10.3 10.3 0 0 1 3.345-2.6A9.2 9.2 0 0 1 10.544.25q2.031 0 3.819.758A10 10 0 0 1 17.49 3.08a9.7 9.7 0 0 1 2.112 3.074q.772 1.761.772 3.792a9.5 9.5 0 0 1-.772 3.819 9.8 9.8 0 0 1-2.112 3.114 10.1 10.1 0 0 1-3.128 2.1 9.5 9.5 0 0 1-3.82.771m3.466-5.335-4.17-4.117V4.502h1.625v5.119l3.71 3.629z" })
});
export default SvgClockBack;
